/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelsent1Inputs */

const en_channelsent1 = /** @type {(inputs: Channelsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast started`)
};

const de_channelsent1 = /** @type {(inputs: Channelsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast gestartet`)
};

/**
* | output |
* | --- |
* | "Broadcast started" |
*
* @param {Channelsent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelsent1 = /** @type {((inputs?: Channelsent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelsent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelsent1(inputs)
	return de_channelsent1(inputs)
});
export { channelsent1 as "channelSent" }